import './BroadcastFilter.sass';

import React, { FC, useCallback } from 'react';
import { RadioItem } from '$uikit';

import { BroadcastFilterProps } from './BroadcastFilter.interface';
import { classNames as cn } from '$utils';
import { useDispatch, useSelector } from 'react-redux';
import { imActions, imBroadcastActiveFilterSelector } from '$store/im';
import { BroadcastFilterName } from '$store/im/interface';
import { RootState } from '$store/rootReducer';

export const BroadcastFilter: FC<BroadcastFilterProps> = (props) => {
  const dispatch = useDispatch();
  const active = useSelector((state: RootState) =>
    imBroadcastActiveFilterSelector(state, props.filterName),
  );

  const handleClickActive = (value) =>
    dispatch(
      imActions.setBroadcastFilterActive({
        filterName: props.filterName,
        isActive: value,
      }),
    );

  return (
    <div className={cn('BroadcastFilter', { active })}>
      <div className="BroadcastFilter__title" onClick={() => handleClickActive(!active)}>
        <RadioItem active={active} />
        {props.title}
      </div>
      <div
        onPointerDown={() => props.setActiveOnClickContent && handleClickActive(true)}
        className="BroadcastFilter__content"
      >
        {props.children}
      </div>
    </div>
  );
};
